import * as React from "react";
import MaterialSearch from "../../../../../model/material/MaterialSearch";
import Modal from "../../../../ui/modal/Modal";
import CurrencyInput from "../../../../../hiberUiKit/src/atoms/Input/CurrencyInput";
import {option, Option} from "ts-option";
import ButtonSecondary from "../../../../../hiberUiKit/src/atoms/Buttons/ButtonSecondary";
import ButtonPrimary from "../../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import {api} from "../../../../../api/api";
import Toast from "../../../../helper/Toast";
import {notifyBugsnagAndShowToast} from "../../../../../utils/Utils";
import "./editMaterialModal.scss";
import JsonConverter from "../../../../../api/helper/JsonConverter";
import SectionSeparator from "../../../../layout/section/SectionSeparator";
import ButtonGroupWrapper from "../../../../../hiberUiKit/src/atoms/Buttons/ButtonGroupWrapper";

interface IProps {
	/**
	 * Material to edit.
	 */
	material: MaterialSearch;
	/**
	 * On close callback
	 */
	onClose: () => void;
	/**
	 * Successful edit action callback
	 */
	onSuccess: () => void;
}

interface IState {
	/**
	 * New price to set for material.
	 */
	price: string;
}

export default class EditMaterialModal extends React.Component<IProps, IState> {

	constructor(props: IProps) {
		super(props);
		this.state = {price: props.material.price.map(p => p.toString()).getOrElse("")};
	}

	render() {
		return (
			<Modal onCloseClicked={this.props.onClose} title="Edit material price" mediumWidth>
				<div className="c-edit-material-modal_content-container">
					<CurrencyInput value={option(this.state.price)} onChange={this.onChange}/>
				</div>
				<SectionSeparator style={{margin: "20px 0"}}/>
				<ButtonGroupWrapper isRight>
					<ButtonSecondary label={"Cancel"} onClick={this.props.onClose}/>
					<ButtonPrimary label={"Submit"} onClick={this.onSubmit}/>
				</ButtonGroupWrapper>
			</Modal>
		);
	}

	onChange = (value: Option<string>) => this.setState({price: value.getOrElse("")});

	onSubmit = () => {
		const newPrice = this.state.price.length ? Number(this.state.price) : undefined;
		const updateData = JsonConverter.removeEmptyFields({price: newPrice});
		api.instance.jobBillOfMaterialsApi.updateMaterial(this.props.material.id, updateData)
			.then(() => {
				Toast.success("Material updated successfully", "Edit material");
				this.props.onSuccess();
			})
			.catch(error => notifyBugsnagAndShowToast(error, "Edit material"));
	}
}
